import ApiClient from "@/services/ApiClient";

export function getAuthCode(params) {
    return ApiClient.post('/auth/oauth2/code', params);
}

export function logIntoApplication(oauthParams) {
    return getAuthCode(oauthParams)
        .then(({data}) => {
            return window.location.assign(oauthParams.redirectUri + '?code=' + data.data.code + '&state=' + oauthParams.state + '&scope=' + oauthParams.scope + '&prompt=consent');
        })
}